import cn from 'classnames';
import React from 'react';
import { Button } from '@vtblife/uikit';
import useDOMRoot from '@vtblife/uikit/dist/hooks/use-dom-root';
import ReactDOM from 'react-dom';
import styles from './quiz-modal-layout.module.css';
export const QuizModalLayout = ({ open, ...props }) => {
    if (!open) {
        return null;
    }
    return React.createElement(CreatePortal, { ...props });
};
function CreatePortal(props) {
    const root = useDOMRoot({ anchor: 'modal-launchpad', style: styles.root });
    if (!root) {
        return null;
    }
    return ReactDOM.createPortal(React.createElement(Layout, { ...props }), root);
}
const Layout = ({ background, children, onClose, layout = '6c', currentStep, disableClosing }) => {
    return (React.createElement("div", { className: cn(styles.container, styles[`background-${background}`], styles[`layout-${layout}`]) },
        !disableClosing && (React.createElement(React.Fragment, null,
            background === 'transparent' && (React.createElement("div", { className: styles.overlay, onClick: () => onClose({ quizStep: currentStep }) })),
            !disableClosing && (React.createElement("span", { className: styles.close },
                React.createElement(Button, { icon: "times", size: "l", circle: true, variant: "transparent", onClick: () => onClose({ quizStep: currentStep }), iconColor: background === 'transparent' ? 'rgb(255, 255, 255)' : 'rgba(116, 109, 147, 0.5)' }))))),
        React.createElement("div", { className: styles.contentBlock },
            React.createElement("div", { className: styles.contentBlockInner }, children))));
};
//# sourceMappingURL=quiz-modal-layout.js.map